<template>
  <Icon
    :name="name"
    :size="size"
    :color="color"
    :class="computedClasses"
    v-bind="$attrs"
  />
</template>

<script setup lang="ts">
const colorMode = useColorMode();
const isLight = computed(() => colorMode.value !== "dark");

interface Props {
  name: string;
  class?: string | string[];
  size?: string | number;
  color?: string;
}

const props = withDefaults(defineProps<Props>(), {
  class: "",
  size: 40,
  color: "currentColor",
});

const computedClasses = computed(() => {
const hasCustomSize = typeof props.class === 'string' && /\b(w-|h-|size-)/.test(props.class);
const hasCustomColor = typeof props.class === 'string' && /\btext-/.test(props.class);
  return [
    // Apply default size (40px) only if no custom w-*/h-* class or size prop is set
    !hasCustomSize && !props.size ? "w-[40px] h-[40px]" : hasCustomSize || props.size,
    // Apply default theme colors only if no custom text-* class or color prop is set
    !hasCustomColor && !props.color
      ? isLight.value
        ? "text-[#613FAA]"
        : "text-white"
      : "",
    props.class,
  ];
});
</script>